import { render } from "./CopyrightComponent.vue?vue&type=template&id=a68d358a"
import script from "./CopyrightComponent.vue?vue&type=script&lang=js"
export * from "./CopyrightComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__